export default __webpack_public_path__ + "static/media/Wellingtons-Regular.f680a0ea.woff2";